import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import ScrollToTop from "./components/ScrollToTop";
import { BrowserRouter as Router } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import Loading from "./components/Loading";

const renderLoader = () => <Loading />;
ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Suspense fallback={renderLoader()}>
        <ScrollToTop>
          <App />
        </ScrollToTop>
      </Suspense>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
